import { useState } from 'react';
import type { Space, UserRole } from '@/types';
import { SPACES_BY_ROLE } from '@/config/static/workspace';

export function useSpaces(role: UserRole) {
  const [spaces] = useState<Space[]>(SPACES_BY_ROLE[role] ?? []);
  return { spaces };
}
